// Comercios que pidieron no exponer su teléfono en las superficies públicas.
// Lista de company ids separados por coma en NEXT_PUBLIC_PRIVATE_PHONE_FF_IDS.
const parseIds = (raw?: string): Set<string> =>
  new Set(
    (raw ?? '')
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean),
  );

export const isPrivatePhoneCompany = (companyId?: number | string | null): boolean => {
  if (companyId === null || companyId === undefined || companyId === '') {
    return false;
  }

  return parseIds(process.env.NEXT_PUBLIC_PRIVATE_PHONE_FF_IDS).has(String(companyId));
};
